export const checkPasswordHasRequiredLength = (password: string, minLength = 8) => password.length >= minLength;

export const checkPasswordHasNumbers = (password: string) => /\d/.test(password);

export const checkPasswordHasUpperCases = (password: string) => /[A-Z]/.test(password);

export const checkPasswordHasLowerCases = (password: string) => /[a-z]/.test(password);

export const checkPasswordHasSpecialChars = (password: string) => /[ `!@#$%^&*()_+\-=[\]{};':"|,.<>/?~]/.test(password);
